import { ChangeDetectorRef, Component, NgZone, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppConstants } from 'src/app/core/constants/appconstants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceExportExcel } from 'src/app/core/services/export.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { UploadAplComponent } from './upload-apl/upload-apl.component';
import { BoundaryAuditComponent } from './boundary-audit/boundary-audit.component';
import { LandmarkComponent } from './landmark/landmark.component';
import { ZoneRenameComponent } from './zone-rename/zone-rename.component';
import { round } from "lodash";
import $ from "jquery";
import * as L from "leaflet";
import "leaflet-draw";
import 'leaflet.markercluster';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
declare let google: any;

@Component({
  selector: 'app-master-routing',
  templateUrl: './master-routing.component.html',
  styleUrls: ['./master-routing.component.scss']
})
export class MasterRoutingComponent implements OnInit {

  public _mFormGroup: FormGroup;
  public location = new FormControl('', Validators.required);
  public site = new FormControl('', Validators.required);

  isOsm: boolean = false;
  showGoogleMap = false;
  private googleMapInitialized = false;
  private mapLoadAttempts = 0;
  private readonly maxMapLoadAttempts = 30;
  editZoneFlag: boolean = false;
  polygonEditingFlag: boolean = false;
  addZoneFlag: boolean = false;
  viewMasterZone: boolean = false;
  showzone: boolean = false;
  isGeofenceChanged: boolean = false;
  viewStatsDetail: boolean = false;
  masterZoneData: boolean = false;
  isStats: boolean = false;
  showBoundary: boolean = true;
  editSiteBoundryFlag: boolean = true;
  isMasterZoneEdit: boolean = false;
  viewAllZone: boolean = false;
  isGeofence: boolean;
  cities: any;
  sites: any;
  citySelected: any;
  selectedCity: any;
  selectedCityValue: any = '';
  newZone: any;
  newzone2: any;
  zoneName: any;
  editingPoly: any;
  masterZoneName: any;
  selectedzone: any;
  autoSelectedzone: any;
  markerClusterer: any;
  drawingManager: any;
  private googleMapClickListener: any;
  private googleOverlayCompleteListener: any;
  private googleDrawClickListener: any;
  private googleDrawDblClickListener: any;
  googleDrawPath: any[] = [];
  isDrawingPolygon = false;
  private googleDrawPreview: any;
  private googleDrawOnComplete: ((polydata: any) => void) | null = null;
  private googleDrawVertexMarkers: any[] = [];
  private googleDrawMoveListener: any;
  private googleDrawMouseOutListener: any;
  private googleDrawGuide: any;
  private suppressGoogleMapClick = false;
  private lastGoogleDrawClickAt = 0;
  private skipGoogleHandleClick = false;
  private googleDrawToolbarAttached = false;
  googleDrawTooltipText = 'Click to start drawing shape.';
  googleDrawTooltipX = 0;
  googleDrawTooltipY = 0;
  showGoogleDrawTooltip = false;
  editablePolydata: any;
  editableLayer: any;
  newZoneLayer: any;
  /** Google Maps polygon created while adding a new zone (cleared after save/reset). */
  private newGoogleZonePolygon: any = null;
  private googleVertexMarkers: any[] = [];
  private googleMidpointMarkers: any[] = [];
  editedZone: any;
  alFilter: any;
  editzonebounds: any = [];
  masterzone: any = [];
  polydata: any = {};
  map: any = {};
  zones: any = [];
  zonebounds: any = [];
  als_markers = [];
  siteMarker: any = [];
  sitePolydata: any[] = [];
  polylines: any[] = [];
  landMarkList: any[] = [];
  geocodes = [];
  zonePoly: any[] = [];
  editPath: any[] = [];
  allZones: any[] = [];
  editingZoneId: any = 0;
  exceptionPointC: number = 0;
  homePointC: number = 0;
  commonPointC: number = 0;
  totalAlC: number = 0;
  selectedSite: number;
  selectedSiteObj: any = {};
  markerpos = { lat: 0, lng: 0 };
  lat = 13.0196;
  lng = 77.5968;
  activeTabId = 1;
  metroStations: any = [];
  metroFlag: boolean;
  templandMarkList: any;
  landmarkValue: string = "Search by area";
  _mCurrentUser: any;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private readonly apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private serviceLocalStorage: ServiceLocalStorage,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
    private serviceExportExcel: ServiceExportExcel,
    public serviceSharedData: ServiceSharedData
  ) {
    this._mFormGroup = this.fb.group({
      'location': this.location,
      'site': this.site,
    });
  }

  ngOnInit() {
    this.loadCities();
    navigator.geolocation?.getCurrentPosition(position => {
      this.lat = position.coords.latitude;
      this.lng = position.coords.longitude;
    });
    this._mCurrentUser = this.serviceLocalStorage.getUserObject();
    this.resolveMapTypeAndInit();
  }

  /** Uses client master-config flag (same as trip-map / trip-modify). */
  private resolveMapTypeAndInit(): void {
    const clientCode = localStorage.getItem('clientCode');
    if (!clientCode) {
      this.initMapByClientFlag();
      return;
    }
    this.apiService.doGetRequestWithResponse(
      ApiConstants.getMapType + clientCode,
      success => {
        if (success.status === 200) {
          this.serviceLocalStorage.setGoogleMapTypeEnabled(!!success.body?.isGoogleMapEnabled);
        }
        this.initMapByClientFlag();
      },
      () => this.initMapByClientFlag()
    );
  }

  private initMapByClientFlag(): void {
    this.showGoogleMap = this.serviceLocalStorage.isSetGoogleMapTypeEnabled();
    this.isOsm = !this.showGoogleMap;
    this.googleMapInitialized = false;
    this.mapLoadAttempts = 0;
    this.cd.detectChanges();
    if (this.isOsm) {
      this.initOSMap();
    } else {
      this.initGMap();
    }
  }

  omit_special_char_And_String(event) {
    var k;
    k = event.charCode; //         k = event.keyCode;  (Both can be used)
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  loadCities() {
    let companyid: number = +this.serviceLocalStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyid, success => {
      this.cities = success.body;

      // Prefill City with first available when page loads
      if (!this.location.value && this.cities && this.cities.length > 0) {
        const firstCity = this.cities[0];
        this.location.setValue(firstCity.locationId || firstCity.id || '');
        // Set selectedCity and load sites for the selected location
        this.onCityChange(this.location.value);
      }
    }, error => {
      console.log(error)
    });
  }

  onCityChange(locationId) {
    this.selectedCity = this.cities.find(x => x.locationId == locationId);
    this.getSitesByCityId(locationId);
  }

  getSitesByCityId(cityId) {
    this.apiService.doGetRequestWithResponse(ApiConstants.getSiteListByLocationIdV3 + cityId, success => {
      if (success != null) {
        this.sites = success.body;
        this.plotSite();

        // Prefill Site with first available when sites load
        if (this.sites && this.sites.length > 0) {
          const firstSiteId = this.sites[0].siteId;
          this.site.setValue(firstSiteId);
          // Trigger site change logic
          this.onSiteChange({ target: { value: firstSiteId } } as any);
        }
      } else {
        this.isGeofence = false;
        this.sites = null;
        this.polylines.forEach(polylin => {
          polylin.setMap(null);
        });
        this.polylines = [];
        this.siteMarker.forEach(sitemarker => {
          sitemarker.setMap(null);
        });
        this.siteMarker = [];
      }
    }, error => {
      console.log(error)
      this.notifyService.showInfo("No Sites Found!", null);
    });
  }

  onSiteChange(event) {
    const site = this.sites.find(ele => ele.siteId == event.target.value);
    const { latitude, longitude } = site.landmark;
    Object.assign(this, {
      viewMasterZone: false, masterZoneName: "", addZoneFlag: false,
      zoneName: null, zones: [], showzone: false, sitePolydata: [],
      isGeofenceChanged: false, viewStatsDetail: false
    });
    this.masterzone = [];
    this.masterZoneData = false;
    this.selectedzone = null;
    this.autoSelectedzone = null;
    this.isOsm ? this.loadOsmap() : this.loadgmap();
    this.polylines.forEach(polylin =>
      this.isOsm ? this.map.removeLayer(polylin) : (typeof polylin?.setMap === 'function' && polylin.setMap(null))
    );
    if (this.isOsm) {
      this.map.panTo(new L.LatLng(latitude, longitude));
    } else if (this.map?.setCenter) {
      this.map.setCenter({ lat: Number(latitude), lng: Number(longitude) });
    }
    this.selectedSite = site.siteId;
    this.selectedSiteObj = site;
    this.isGeofence = !!site.boundary;
    if (!this.isGeofence) this.masterzone = [];
    this.getMetroStationsCount();
    this.showBoundaries(this.selectedSiteObj);
    this.getMasterZone();
    this.landmarkCountbytype(this.selectedCity.locationId, this.selectedSite);
  }

  getMasterZone() {
    this.apiService.doGetRequestWithResponse(ApiConstants.masterZone + this.selectedSite, success => {
      if (success.status == 200) {
        this.masterZoneData = true;
        this.masterzone = success.body;
        this.selectedzone = this.masterzone[0];
        this.autoSelectedzone = this.masterzone[0].id;
      } else {
        this.masterZoneData = false;
        this.masterzone = [];
        this.selectedzone = null;
        this.autoSelectedzone = null;
      }
    }, error => {
      console.log(error)
      this.masterzone = [];
    });
  }

  saveMasteZone(masterZone) {
    if (!masterZone?.trim()) {
      this.notifyService.showWarning("Please enter zone name", null);
      return;
    }

    this.apiService.doPostRequestWithResponse(
      `${ApiConstants.addMasterZone}${masterZone}&siteid=${this.selectedSite}`,
      '',
      success => {
        const messages = {
          201: () => { this.getMasterZone(); this.notifyService.showSuccess(success.body.message, null); },
          208: () => this.notifyService.showWarning(success.body.message, null),
          default: () => this.notifyService.showWarning("No Access", null)
        };
        (messages[success.status] || messages.default)();
      },
      error => console.log(error)
    );
  }

  landmarkCountbytype(locationId, siteId) {
    this.clearMarkers();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.landmarkCountbytype}${locationId}&siteId=${siteId}`,
      success => {
        if (success.status === 200) {
          const { Exceptions, HOME, COMMON, TOTAL } = success.body;
          Object.assign(this, {
            exceptionPointC: Exceptions,
            homePointC: HOME,
            commonPointC: COMMON,
            totalAlC: TOTAL,
            isStats: TOTAL > 0
          });
          if (!TOTAL) this.notifyService.showInfo("No landmarks found for selected site", null);
        }
      },
      error => console.log(error)
    );
  }

  getAreaLandmarkByType(type) {
    this.ngxLoader.start();
    this.metroFlag = false;

    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getlandmarkbytype}${this.selectedCity.locationId}&type=${type}&siteId=${this.selectedSite}`,
      success => {
        this.ngxLoader.stop();
        const isSuccess = success.status === 200;

        Object.assign(this, {
          viewStatsDetail: isSuccess,
          landmarkValue: isSuccess ? "Search by area" : this.landmarkValue,
          landMarkList: isSuccess ? success.body : [],
          templandMarkList: isSuccess ? success.body : []
        });

        if (isSuccess) {
          this.clearMarkers();
          this.markLoadedLandmakrs();
        } else {
          this.notifyService.showInfo("No landmarks found for selected site", null);
        }
      },
      error => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }

  markLoadedLandmakrs() {
    const iconPaths = {
      H: "./assets/images/marker_pin_green.png",
      S: "./assets/images/marker_pin_yellow.png",
      default: "./assets/images/marker_pin.png"
    };

    if (this.isOsm) {
      this.markerClusterer = L.markerClusterGroup();
    } else if (!this.map?.setCenter) {
      this.initGMap(() => this.markLoadedLandmakrs());
      return;
    }

    this.landMarkList
      .filter(landmark => landmark.latitude && landmark.longitude)
      .forEach(landmark => {
        const name = `${landmark.area.area}-${landmark.landmark}`;
        const iconPath = iconPaths[landmark.type] || iconPaths.default;
        this.geocodes.push({ name, id: landmark.id });
        if (this.isOsm) {
          const marker = new L.marker(L.latLng(landmark.latitude, landmark.longitude), {
            icon: new L.Icon({
              iconUrl: iconPath,
              popupAnchor: [0, 0],
              iconSize: [30, 30],
              iconAnchor: [15, 30]
            })
          }).bindPopup(name);
          this.markerClusterer.addLayer(marker);
          this.als_markers.push(this.markerClusterer);
        } else {
          const lat = Number(landmark.latitude);
          const lng = Number(landmark.longitude);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            return;
          }
          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            icon: {
              url: iconPath,
              scaledSize: new google.maps.Size(32, 32),
              anchor: new google.maps.Point(16, 32)
            },
            draggable: false,
            title: name
          });
          const infowindow = new google.maps.InfoWindow({ content: name });
          google.maps.event.addListener(marker, "click", () => infowindow.open(this.map, marker));
          this.als_markers.push(marker);
        }
      });

    if (this.isOsm) {
      this.map.addLayer(this.markerClusterer);
    } else if (this.map?.setCenter) {
      this.markerClusterer = new MarkerClusterer({
        map: this.map,
        markers: this.als_markers,
        renderer: { render: cluster => this.renderGoogleClusterMarker(cluster) }
      });
    }
  }

  /** Cluster colors: green (<10), yellow (<100), orange (>=100) — Leaflet MarkerCluster defaults. */
  private renderGoogleClusterMarker({ count, position }: { count: number; position: any }) {
    let size = 40;
    let outer = 'rgba(181, 226, 140, 0.6)';
    let inner = 'rgba(110, 204, 57, 0.6)';
    let labelColor = '#1b5e20';
    if (count >= 100) {
      size = 56;
      outer = 'rgba(253, 156, 115, 0.6)';
      inner = 'rgba(241, 128, 23, 0.6)';
      labelColor = '#5d1a00';
    } else if (count >= 10) {
      size = 48;
      outer = 'rgba(241, 211, 87, 0.6)';
      inner = 'rgba(240, 194, 12, 0.6)';
      labelColor = '#5d4a00';
    }
    const cx = size / 2;
    const svg = window.btoa(
      `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">` +
      `<circle cx="${cx}" cy="${cx}" r="${cx}" fill="${outer}"/>` +
      `<circle cx="${cx}" cy="${cx}" r="${cx * 0.62}" fill="${inner}"/>` +
      `</svg>`
    );
    return new google.maps.Marker({
      position,
      icon: {
        url: `data:image/svg+xml;base64,${svg}`,
        scaledSize: new google.maps.Size(size, size),
        anchor: new google.maps.Point(cx, cx)
      },
      label: {
        text: String(count),
        color: labelColor,
        fontWeight: '700',
        fontSize: count >= 100 ? '13px' : '12px'
      },
      zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count
    });
  }

  deleteLandmark(landmarkId) {
    if (confirm("Do you want to remove this geo-code?")) {
      this.apiService.doGetRequestWithResponse(ApiConstants.deleteLandmark + landmarkId, success => {
        if (success.status == 200) {
          this.landmarkCountbytype(
            this.selectedCity.locationId,
            this.selectedSite
          );
          this.notifyService.showSuccess(success.body.message, null);
        } else if (success.status == 202) {
          this.notifyService.showInfo(success.body.message, null);
        }
      }, error => {
        console.log(error)
      });
    }
  }

  clearMarkers() {
    if (this.isOsm) {
      this.als_markers.forEach(marker => this.map.removeLayer(marker));
      this.als_markers = [];
      return;
    }

    if (typeof this.markerClusterer?.clearMarkers === 'function') {
      this.markerClusterer.clearMarkers();
    }
    if (typeof this.markerClusterer?.setMap === 'function') {
      this.markerClusterer.setMap(null);
    }
    this.als_markers.forEach(marker => {
      if (typeof marker?.setMap === 'function') {
        marker.setMap(null);
      }
    });
    this.markerClusterer = null;
    this.als_markers = [];
  }

  initOSMap() {
    this.map = L.map("map", {
      fullscreenControl: true,
      dragging: true
    }).setView([this._mCurrentUser.userInfoDetails.site.landmark.latitude, this._mCurrentUser.userInfoDetails.site.landmark.longitude], 13);
    L.tileLayer(AppConstants.OSM_TILE, { attribution: AppConstants.OSM_CONTRIBUTORS }).addTo(this.map);
  }

  initGMap(afterInit?: () => void) {
    if (!this.showGoogleMap || this.isOsm) {
      return;
    }
    if (this.googleMapInitialized && this.map?.setCenter) {
      afterInit?.();
      return;
    }
    const mapEl = document.getElementById('map');
    if (!mapEl) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    if (typeof google === 'undefined' || (!google.maps?.Map && !google.maps?.importLibrary)) {
      this.scheduleGoogleMapLoadRetry(afterInit);
      return;
    }
    this.initGoogleMapAsync(mapEl, afterInit);
  }

  private scheduleGoogleMapLoadRetry(afterInit?: () => void): void {
    if (++this.mapLoadAttempts >= this.maxMapLoadAttempts) {
      afterInit?.();
      return;
    }
    setTimeout(() => this.initGMap(afterInit), 100);
  }

  private async initGoogleMapAsync(mapEl: HTMLElement, afterInit?: () => void): Promise<void> {
    if (this.googleMapInitialized && this.map?.setCenter) {
      afterInit?.();
      return;
    }
    try {
      const mapCenter = {
        lat: this._mCurrentUser.userInfoDetails.site.landmark.latitude,
        lng: this._mCurrentUser.userInfoDetails.site.landmark.longitude
      };
      let MapClass = google.maps?.Map;
      if (google.maps?.importLibrary) {
        const mapsLib = await google.maps.importLibrary('maps') as any;
        MapClass = mapsLib.Map;
      }
      if (!MapClass) {
        this.scheduleGoogleMapLoadRetry(afterInit);
        return;
      }
      this.map = new MapClass(mapEl, {
        center: mapCenter,
        zoom: 12,
        draggable: true,
        zoomControl: true,
        gestureHandling: 'greedy',
        zoomControlOptions: {
          position: google.maps.ControlPosition?.LEFT_TOP || 5
        },
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition?.LEFT_TOP || 5
        },
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition?.TOP_LEFT || 1
        }
      });
      this.googleMapInitialized = true;
      google.maps.event.addListenerOnce(this.map, 'idle', () => {
        google.maps.event.trigger(this.map, 'resize');
        this.map.setCenter(mapCenter);
        afterInit?.();
      });
    } catch (error) {
      console.error('Google Map init failed', error);
      this.scheduleGoogleMapLoadRetry(afterInit);
    }
  }

  private async ensureDrawingLibrary(): Promise<void> {
    if (google.maps?.drawing?.DrawingManager) {
      return;
    }
    if (google.maps?.importLibrary) {
      try {
        await google.maps.importLibrary('drawing');
      } catch (error) {
        console.error('Google drawing library failed to load', error);
      }
    }
  }

  hideBoundary(flag) {
    this.showBoundary = flag;
    this.polylines.forEach(poly => {
      if (this.isOsm) {
        flag ? this.map.addLayer(poly) : this.map.removeLayer(poly);
      } else if (typeof poly?.setMap === 'function') {
        poly.setMap(flag ? this.map : null);
      }
    });
    if (!this.isOsm) {
      this.sitePolydata.forEach(entry => {
        if (typeof entry?.polydata?.setMap === 'function') {
          entry.polydata.setMap(flag ? this.map : null);
        }
      });
    }
  }

  removeNewZoneControl() {
    if (this.newZone) {
      this.map.removeControl(this.newZone);
    }
  }

  removeEditControlAndLayer() {
    if (this.editablePolydata) {
      this.map.removeLayer(this.editableLayer);
      this.map.removeControl(this.editablePolydata);
    }
  }

  onReset() {
    if (!this.isOsm) {
      this.stopGooglePolygonDraw();
      this.clearGoogleDrawnZone();
      this.clearGoogleZonePolygons();
    }
    this.isOsm ? this.loadOsmap() : this.loadgmap();
    this.zones = [];
    this.zonebounds = [];
    this.editingZoneId = 0;
    this.editZoneFlag = false;
    this.polygonEditingFlag = false;
    this.addZoneFlag = false;
    this.zoneName = null;
  }

  /** Remove the temporary Google zone polygon from the map (OSM uses newZoneLayer). */
  private clearGoogleDrawnZone(): void {
    if (this.isOsm) {
      return;
    }
    if (this.newGoogleZonePolygon?.setMap) {
      this.newGoogleZonePolygon.setMap(null);
    }
    this.newGoogleZonePolygon = null;
    this.clearGoogleVertexHandles();
  }

  /** Remove edited/viewed Google zone polygons so they do not linger after save/reset. */
  private clearGoogleZonePolygons(): void {
    if (this.isOsm) {
      return;
    }
    this.clearGoogleVertexHandles();
    this.setGoogleCoveringPolygonsClickable(true);
    this.zonePoly.forEach(poly => {
      if (typeof poly?.setMap === 'function') {
        poly.setMap(null);
      }
    });
    this.zonePoly = [];
  }

  loadOsmap() {
    this.map.on("click", e => {
      if (!this.isGeofence) {
        const marker = new L.marker(e.latLng, {
          icon: new L.Icon({
            iconUrl: "./assets/images/marker_pin.png",
            popupAnchor: [0, 0],
            iconSize: [40, 40],
            iconAnchor: [20, 40]
          })
        }).addTo(this.map).bindPopup("New");
        this.markerpos = { lat: e.latLng.lat, lng: e.latLng.lng };
        this.als_markers.push(marker);
      }
    });
    if (this.sites) this.plotSite();
    if (this.selectedSiteObj.landmark) {
      const { latitude, longitude } = this.selectedSiteObj.landmark;
      this.map.panTo(new L.LatLng(latitude, longitude));
      this.showBoundaries(this.selectedSiteObj);
    }
  }

  loadgmap() {
    if (!this.map?.setCenter) {
      this.initGMap(() => this.loadgmap());
      return;
    }
    if (this.googleMapClickListener) {
      google.maps.event.removeListener(this.googleMapClickListener);
    }
    this.googleMapClickListener = google.maps.event.addListener(this.map, "click", event => {
      if (!this.isGeofence && !this.polygonEditingFlag && !this.editZoneFlag) {
        const marker = new google.maps.Marker({
          position: event.latLng,
          icon: "./assets/images/marker_pin.png",
          draggable: true,
          animation: google.maps.Animation.DROP,
          map: this.map,
          title: "New"
        });
        this.markerpos = { lat: event.latLng.lat(), lng: event.latLng.lng() };
        this.als_markers.push(marker);
      }
    });

    if (this.sites) this.plotSite();
    if (this.selectedSiteObj.landmark) {
      const { latitude, longitude } = this.selectedSiteObj.landmark;
      this.map.setCenter({ lat: Number(latitude), lng: Number(longitude) });
      this.showBoundaries(this.selectedSiteObj);
    }
  }

  plotSite() {
    this.siteMarker.forEach(marker =>
      this.isOsm ? this.map.removeLayer(marker) : marker.setMap(null)
    );
    this.siteMarker = [];
    this.sites.forEach(site => {
      const { latitude, longitude } = site.landmark;
      if (this.isOsm) {
        const marker = new L.marker(L.latLng(latitude, longitude), {
          icon: new L.Icon({
            iconUrl: "./assets/images/company.png",
            popupAnchor: [0, 0],
            iconSize: [40, 40],
            iconAnchor: [20, 40]
          })
        }).addTo(this.map).bindPopup(site.siteName);
        this.siteMarker.push(marker);
      } else {
        if (!this.map?.setCenter) {
          this.initGMap(() => this.plotSite());
          return;
        }
        const lat = Number(latitude);
        const lng = Number(longitude);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
          return;
        }
        const marker = new google.maps.Marker({
          position: new google.maps.LatLng(lat, lng),
          icon: {
            url: "./assets/images/company.png",
            scaledSize: new google.maps.Size(40, 40)
          },
          map: this.map
        });
        const infowindow = new google.maps.InfoWindow({ content: site.siteName });
        google.maps.event.addListener(marker, "click", () =>
          infowindow.open(this.map, marker)
        );
        this.siteMarker.push(marker);
      }
    });
  }

  clearMap() {
    if (this.isOsm) {
      this.map.remove();
      this.initOSMap();
      this.onSiteChange(this.selectedSiteObj);
      return;
    }
    this.googleMapInitialized = false;
    this.mapLoadAttempts = 0;
    this.map = null;
    this.initGMap(() => this.onSiteChange(this.selectedSiteObj));
  }

  onUploadAPL() {
    let dialogRef = this.dialog.open(UploadAplComponent, {
      width: "400px",
      data: this.selectedCity.locationId,
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      this.landmarkCountbytype(this.selectedCity.locationId, this.selectedSite);
    });
  }

  showBoundaries(site) {
    this.sitePolydata = [];
    let path: any = [];
    let polydata;
    let boundary = site.boundary ? site.boundary : "";
    if (this.editingPoly) {
      boundary = this.converPolyArrayToString(this.editingPoly);
    }
    if (boundary.length) {
      let boundaryArr: any = boundary.split("),(");
      if (this.isOsm) {
        this.polylines.forEach(polylin => {
          this.map.removeLayer(polylin);
        });
        this.polylines = [];
        boundaryArr.forEach(element => {
          if (element.includes("(")) element = element.split("(")[1];
          if (element.includes(")")) element = element.split(")")[0];
          path.push({
            lat: parseFloat(element.split(",")[0]),
            lng: parseFloat(element.split(",")[1])
          });
        });
        const editableLayers = new L.FeatureGroup();
        this.map.addLayer(editableLayers);
        editableLayers.addLayer(
          L.polygon(path).setStyle({
            color: "#143454",
            fillColor: "#58abff",
            weight: 2
          })
        );
        this.sitePolydata.push({
          id: site.siteId,
          polydata: editableLayers
        });
        this.polylines.push(editableLayers);
      } else {
        if (!this.map?.setCenter) {
          this.initGMap(() => this.showBoundaries(site));
          return;
        }
        let infoWindow = new google.maps.InfoWindow();
        this.polylines.forEach(polylin => {
          if (typeof polylin?.setMap === 'function') {
            polylin.setMap(null);
          }
        });
        this.polylines = [];
        boundaryArr.forEach(element => {
          if (element.includes("(")) element = element.split("(")[1];
          if (element.includes(")")) element = element.split(")")[0];
          const lat = Number(element.split(",")[0]);
          const lng = Number(element.split(",")[1]);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            return;
          }
          path.push(new google.maps.LatLng(lat, lng));
        });
        if (!path.length) {
          return;
        }
        polydata = new google.maps.Polygon({
          paths: path,
          map: this.showBoundary ? this.map : null,
          editable: false,
          clickable: !this.editZoneFlag,
          zIndex: 1,
          strokeColor: "#143454",
          strokeWeight: 2,
          fillColor: "#58abff",
          fillOpacity: this.selectedSite == site.siteId ? 0.35 : 0.2
        });
        polydata.addListener("mousemove", event => {
          let timer = setTimeout(function () {
            infoWindow.close();
          }, 1000);
          infoWindow.setContent(site.siteName);
          infoWindow.setPosition(event.latLng);
        });
        // Keep only this site's boundary on Google Maps
        this.sitePolydata = [{ id: site.siteId, polydata: polydata }];
        this.polylines = [polydata];
      }
    }
  }

  converPolyArrayToString(polyarray) {
    return polyarray
      .map(obj => `(${this.isOsm ? obj.lat : obj.lat()},${this.isOsm ? obj.lng : obj.lng()})`)
      .join(",");
  }

  downloadGeoCodes() {
    if (!this.landMarkList.length) return;
    const geoCodeArray = this.landMarkList.map(landMark =>
      this.metroFlag
        ? {
          stationName: landMark.stationName,
          metroRouteName: landMark.metroRouteName,
          lat: landMark.latitude,
          lng: landMark.longitude,
          siteName: landMark.site.siteName
        }
        : {
          Area: landMark.area.area,
          Landmark: landMark.landmark,
          lat: landMark.latitude,
          lng: landMark.longitude,
          type: landMark.type
        }
    );
    this.serviceExportExcel.exportAsExcelFile(geoCodeArray, this.metroFlag ? "Metro_Stations" : "Landmarks");
  }

  async createGeofence() {
    this.polygonEditingFlag = true;
    if (!this.isOsm) {
      await this.startGooglePolygonDraw(polydata => {
        polydata.setOptions({ fillColor: '#FFF176', editable: false, clickable: true, zIndex: 10 });
        this.polylines.push(polydata);
        this.editingPoly = polydata.getPath().getArray();
        this.isGeofenceChanged = true;
        this.attachGoogleZoneVertexHandles(polydata, () => {
          this.editingPoly = polydata.getPath().getArray();
          this.isGeofenceChanged = true;
        });
        this.cd.detectChanges();
      });
    } else {
      if (this.editSiteBoundryFlag) {
        this.editSiteBoundryFlag = false;
        const editableLayers = new L.FeatureGroup();
        this.map.addLayer(editableLayers);
        const polydata = new L.Control.Draw({
          edit: {
            featureGroup: editableLayers,
            remove: false
          },
          draw: {
            polygon: {
              allowIntersection: true
            },
            polyline: false,
            circle: false,
            rectangle: false,
            marker: false
          }
        });
        this.map.addControl(polydata);
        let element: HTMLElement = document.getElementsByClassName("leaflet-draw-draw-polygon")[0] as HTMLElement;
        element.click();
        this.map.on("draw:created", e => {
          this.isGeofenceChanged = true;
          this.polylines.push(polydata);
          this.editingPoly = e.layer._latlngs[0];
          this.map.removeControl(polydata);
          editableLayers.addLayer(e.layer);
        });
      }
    }
  }

  async createDrawingManager() {
    await this.ensureDrawingLibrary();
    if (!google.maps?.drawing?.DrawingManager) {
      return;
    }
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      drawingControl: false,
      polygonOptions: {
        fillColor: '#FFF176',
        fillOpacity: 0.35,
        strokeWeight: 2,
        editable: false
      }
    });
    this.drawingManager.setMap(this.map);
  }

  private async startGooglePolygonDraw(onComplete: (polydata: any) => void): Promise<void> {
    if (!this.map?.setCenter) {
      this.initGMap(() => this.startGooglePolygonDraw(onComplete));
      return;
    }
    this.stopGooglePolygonDraw();
    this.polygonEditingFlag = true;
    this.isDrawingPolygon = true;
    this.googleDrawOnComplete = onComplete;
    this.startGoogleClickPolygonDraw();
    this.cd.detectChanges();
    this.attachGoogleDrawToolbar();
  }

  private startGoogleClickPolygonDraw(): void {
    this.googleDrawPath = [];
    this.lastGoogleDrawClickAt = 0;
    this.clearGoogleDrawVertexMarkers();
    if (this.googleMapClickListener) {
      google.maps.event.removeListener(this.googleMapClickListener);
      this.googleMapClickListener = null;
    }
    this.map.setOptions({ draggableCursor: 'crosshair', draggingCursor: 'crosshair', disableDoubleClickZoom: true });
    this.updateGoogleDrawTooltipText();
    this.googleDrawClickListener = this.map.addListener('click', (e: any) => {
      this.ngZone.run(() => {
        if (this.suppressGoogleMapClick) {
          this.suppressGoogleMapClick = false;
          return;
        }
        if (!this.isDrawingPolygon || !e?.latLng) {
          return;
        }
        const now = Date.now();
        if (now - this.lastGoogleDrawClickAt < 300) {
          return;
        }
        this.lastGoogleDrawClickAt = now;
        this.addGoogleDrawVertex(e.latLng);
        this.cd.detectChanges();
      });
    });
    this.googleDrawDblClickListener = this.map.addListener('dblclick', (e: any) => {
      e?.stop?.();
      this.ngZone.run(() => this.finishGoogleClickPolygonDraw());
    });
    this.googleDrawMoveListener = this.map.addListener('mousemove', (e: any) => {
      this.updateGoogleDrawTooltipFromEvent(e);
      if (!this.isDrawingPolygon || !this.googleDrawPath.length || !e?.latLng) {
        return;
      }
      const guidePath = [this.googleDrawPath[this.googleDrawPath.length - 1], e.latLng];
      if (this.googleDrawGuide?.setPath) {
        this.googleDrawGuide.setPath(guidePath);
        return;
      }
      this.googleDrawGuide = new google.maps.Polyline({
        path: guidePath,
        map: this.map,
        zIndex: 4,
        ...this.googleDashedLineOptions()
      });
    });
    this.googleDrawMouseOutListener = this.map.addListener('mouseout', () => {
      this.showGoogleDrawTooltip = false;
      this.cd.detectChanges();
    });
  }

  private addGoogleDrawVertex(latLng: any): void {
    this.googleDrawPath = [...this.googleDrawPath, latLng];
    const idx = this.googleDrawPath.length - 1;
    const marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      draggable: false,
      clickable: true,
      optimized: false,
      zIndex: 1000000,
      cursor: 'pointer',
      icon: this.googleSquareIcon(8, 1)
    });
    marker.addListener('click', (e: any) => {
      e?.stop?.();
      this.suppressGoogleMapClick = true;
      this.ngZone.run(() => this.onGoogleDrawVertexClick(idx));
    });
    this.googleDrawVertexMarkers.push(marker);
    this.refreshGoogleDrawPreviewLine();
    this.updateGoogleDrawTooltipText();
    this.refreshGoogleDrawFirstVertexCursor();
  }

  /** Leaflet-draw: first vertex closes the shape; last vertex removes the last segment. */
  private onGoogleDrawVertexClick(idx: number): void {
    if (!this.isDrawingPolygon) {
      return;
    }
    if (idx === 0 && this.googleDrawPath.length >= 3) {
      this.finishGoogleClickPolygonDraw();
      return;
    }
    if (idx === this.googleDrawPath.length - 1 && this.googleDrawPath.length > 1) {
      this.removeLastGoogleDrawVertex();
    }
  }

  private removeLastGoogleDrawVertex(): void {
    const marker = this.googleDrawVertexMarkers.pop();
    marker?.setMap?.(null);
    this.googleDrawPath = this.googleDrawPath.slice(0, -1);
    this.refreshGoogleDrawPreviewLine();
    this.updateGoogleDrawTooltipText();
    this.refreshGoogleDrawFirstVertexCursor();
    this.cd.detectChanges();
  }

  deleteLastGoogleDrawPoint(): void {
    if (!this.isDrawingPolygon || this.googleDrawPath.length < 1) {
      return;
    }
    this.removeLastGoogleDrawVertex();
  }

  cancelGooglePolygonDraw(): void {
    if (!this.isDrawingPolygon) {
      return;
    }
    this.stopGooglePolygonDraw();
    this.polygonEditingFlag = false;
    this.showGoogleDrawTooltip = false;
    this.cd.detectChanges();
  }

  private updateGoogleDrawTooltipText(): void {
    const n = this.googleDrawPath.length;
    if (n === 0) {
      this.googleDrawTooltipText = 'Click to start drawing shape.';
    } else if (n < 3) {
      this.googleDrawTooltipText = 'Click to continue drawing shape.';
    } else {
      this.googleDrawTooltipText = 'Click first point to close this shape.';
    }
  }

  private updateGoogleDrawTooltipFromEvent(e: any): void {
    if (!this.isDrawingPolygon) {
      return;
    }
    const wrap = document.querySelector('.mr-map-wrap') as HTMLElement;
    const evt = e?.domEvent;
    if (!wrap || !evt) {
      return;
    }
    const rect = wrap.getBoundingClientRect();
    this.googleDrawTooltipX = evt.clientX - rect.left + 14;
    this.googleDrawTooltipY = evt.clientY - rect.top - 28;
    this.showGoogleDrawTooltip = true;
    this.cd.detectChanges();
  }

  private refreshGoogleDrawFirstVertexCursor(): void {
    const first = this.googleDrawVertexMarkers[0];
    if (!first?.setOptions) {
      return;
    }
    const canClose = this.googleDrawPath.length >= 3;
    first.setOptions({
      cursor: canClose ? 'pointer' : 'crosshair',
      title: canClose ? 'Click first point to close this shape.' : ''
    });
  }

  private refreshGoogleDrawPreviewLine(): void {
    if (this.googleDrawPreview?.setMap) {
      this.googleDrawPreview.setMap(null);
    }
    this.googleDrawPreview = null;
    if (this.googleDrawPath.length > 1) {
      this.googleDrawPreview = new google.maps.Polyline({
        path: this.googleDrawPath,
        map: this.map,
        zIndex: 3,
        ...this.googleDashedLineOptions()
      });
    }
  }

  private clearGoogleDrawVertexMarkers(): void {
    this.googleDrawVertexMarkers.forEach(marker => marker?.setMap?.(null));
    this.googleDrawVertexMarkers = [];
  }

  finishGoogleClickPolygonDraw(): void {
    if (!this.isDrawingPolygon) {
      return;
    }
    if (this.googleDrawPath.length < 3) {
      this.notifyService.showWarning('Click at least 3 points on the map to draw the polygon', null);
      return;
    }
    const path = this.googleDrawPath.slice();
    const onComplete = this.googleDrawOnComplete;
    const polydata = new google.maps.Polygon({
      paths: path,
      editable: false,
      clickable: true,
      zIndex: 10,
      map: this.map,
      fillColor: '#FFF176',
      strokeColor: '#143454',
      strokeWeight: 2
    });
    this.stopGooglePolygonDraw();
    onComplete?.(polydata);
    this.cd.detectChanges();
  }

  private stopGooglePolygonDraw(): void {
    this.detachGoogleDrawToolbar();
    this.isDrawingPolygon = false;
    if (this.googleOverlayCompleteListener) {
      google.maps.event.removeListener(this.googleOverlayCompleteListener);
      this.googleOverlayCompleteListener = null;
    }
    if (this.drawingManager) {
      this.drawingManager.setDrawingMode(null);
      this.drawingManager.setMap(null);
    }
    if (this.googleDrawClickListener) {
      google.maps.event.removeListener(this.googleDrawClickListener);
      this.googleDrawClickListener = null;
    }
    if (this.googleDrawDblClickListener) {
      google.maps.event.removeListener(this.googleDrawDblClickListener);
      this.googleDrawDblClickListener = null;
    }
    if (this.googleDrawMoveListener) {
      google.maps.event.removeListener(this.googleDrawMoveListener);
      this.googleDrawMoveListener = null;
    }
    if (this.googleDrawMouseOutListener) {
      google.maps.event.removeListener(this.googleDrawMouseOutListener);
      this.googleDrawMouseOutListener = null;
    }
    if (this.googleDrawPreview?.setMap) {
      this.googleDrawPreview.setMap(null);
      this.googleDrawPreview = null;
    }
    if (this.googleDrawGuide?.setMap) {
      this.googleDrawGuide.setMap(null);
      this.googleDrawGuide = null;
    }
    this.clearGoogleDrawVertexMarkers();
    this.googleDrawPath = [];
    this.googleDrawOnComplete = null;
    this.showGoogleDrawTooltip = false;
    this.updateGoogleDrawTooltipText();
    if (this.map?.setOptions) {
      this.map.setOptions({ draggableCursor: null, draggingCursor: null, disableDoubleClickZoom: false });
    }
  }

  private attachGoogleDrawToolbar(): void {
    setTimeout(() => {
      const el = document.querySelector('.gm-draw-actions') as HTMLElement;
      if (!el || !this.map?.controls || this.googleDrawToolbarAttached) {
        return;
      }
      el.classList.add('gm-draw-actions-docked');
      const pos = google.maps.ControlPosition?.LEFT_TOP || 5;
      this.map.controls[pos].push(el);
      this.googleDrawToolbarAttached = true;
    }, 0);
  }

  private detachGoogleDrawToolbar(): void {
    const el = document.querySelector('.gm-draw-actions') as HTMLElement;
    if (this.map?.controls) {
      const pos = google.maps.ControlPosition?.LEFT_TOP || 5;
      const ctrls = this.map.controls[pos];
      if (ctrls) {
        for (let i = ctrls.getLength() - 1; i >= 0; i--) {
          if (ctrls.getAt(i) === el || ctrls.getAt(i)?.classList?.contains('gm-draw-actions')) {
            ctrls.removeAt(i);
          }
        }
      }
    }
    if (el) {
      el.classList.remove('gm-draw-actions-docked');
      const wrap = document.querySelector('.mr-map-wrap');
      if (wrap && el.parentElement !== wrap) {
        wrap.appendChild(el);
      }
    }
    this.googleDrawToolbarAttached = false;
  }

  private bindGoogleEditablePath(polydata: any, onChange: () => void): void {
    google.maps.event.addListener(polydata.getPath(), 'set_at', onChange);
    google.maps.event.addListener(polydata.getPath(), 'insert_at', onChange);
    google.maps.event.addListener(polydata.getPath(), 'remove_at', onChange);
  }

  private googleVertexIcon(scale: number): any {
    return this.googleSquareIcon(scale, 1);
  }

  /** Leaflet-draw dashed polyline (blue dash, white vertex squares). */
  private googleDashedLineOptions(): any {
    return {
      strokeColor: '#143454',
      strokeOpacity: 0,
      strokeWeight: 2,
      clickable: false,
      icons: [{
        icon: {
          path: 'M 0,-1 0,1',
          strokeOpacity: 1,
          strokeColor: '#143454',
          scale: 3
        },
        offset: '0',
        repeat: '14px'
      }]
    };
  }

  /** Leaflet vertex = dark solid square; midpoint = lighter smaller square. */
  private googleSquareIcon(scale: number, fillOpacity = 1): any {
    const vertex = fillOpacity >= 0.9;
    const size = 16;
    const strokeColor = vertex ? '#222222' : '#8a8a8a';
    const fillColor = vertex ? '#ffffff' : '#f7f7f7';
    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}">
      <rect x="0.5" y="0.5" width="${size - 1}" height="${size - 1}" fill="${fillColor}" fill-opacity="${fillOpacity}" stroke="${strokeColor}" stroke-width="1"/>
    </svg>`;
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(size, size),
      anchor: new google.maps.Point(size / 2, size / 2)
    };
  }

  private googleVertexSquareIcon(): any {
    return this.googleSquareIcon(8, 1);
  }

  private googleMidpointSquareIcon(): any {
    return this.googleSquareIcon(5, 0.5);
  }

  private clearGoogleVertexHandles(): void {
    this.googleVertexMarkers.forEach(marker => marker?.setMap?.(null));
    this.googleMidpointMarkers.forEach(marker => marker?.setMap?.(null));
    this.googleVertexMarkers = [];
    this.googleMidpointMarkers = [];
  }

  private setGoogleCoveringPolygonsClickable(clickable: boolean): void {
    this.sitePolydata.forEach(entry => {
      entry?.polydata?.setOptions?.({ clickable, zIndex: clickable ? 1 : 0 });
    });
    this.polylines.forEach(poly => {
      if (typeof poly?.setOptions === 'function') {
        poly.setOptions({ clickable, zIndex: clickable ? 1 : 0 });
      }
    });
  }

  /** Leaflet-draw style vertex/midpoint squares: drag, click-to-delete, midpoint click-to-insert. */
  private attachGoogleZoneVertexHandles(polygon: any, onChange?: () => void): void {
    if (!polygon?.getPath || !this.map?.setCenter) {
      return;
    }
    polygon.setOptions?.({ editable: false });
    this.setGoogleCoveringPolygonsClickable(false);
    const sync = () => {
      const pts = polygon.getPath().getArray();
      this.editzonebounds = pts;
      this.zonebounds = pts;
      onChange?.();
    };
    this.buildGoogleZoneVertexHandles(polygon, sync);
  }

  private buildGoogleZoneVertexHandles(polygon: any, onChange?: () => void): void {
    this.clearGoogleVertexHandles();
    const path = polygon.getPath();
    const len = path.getLength();
    if (!len) {
      return;
    }
    const rebuild = () => this.buildGoogleZoneVertexHandles(polygon, onChange);
    for (let i = 0; i < len; i++) {
      const idx = i;
      let dragged = false;
      const marker = new google.maps.Marker({
        position: path.getAt(idx),
        map: this.map,
        draggable: true,
        clickable: true,
        optimized: false,
        zIndex: 1000000,
        cursor: 'pointer',
        icon: this.googleVertexSquareIcon()
      });
      marker.addListener('dragstart', () => {
        dragged = true;
      });
      marker.addListener('drag', (e: any) => {
        if (!e?.latLng) {
          return;
        }
        path.setAt(idx, e.latLng);
        this.syncGoogleMidpointPositions(path);
        onChange?.();
      });
      marker.addListener('dragend', () => {
        this.skipGoogleHandleClick = true;
        onChange?.();
        rebuild();
        setTimeout(() => { this.skipGoogleHandleClick = false; }, 300);
      });
      marker.addListener('click', (e: any) => {
        e?.stop?.();
        this.suppressGoogleMapClick = true;
        if (this.skipGoogleHandleClick || dragged) {
          dragged = false;
          return;
        }
        if (path.getLength() <= 3) {
          return;
        }
        path.removeAt(idx);
        onChange?.();
        rebuild();
      });
      this.googleVertexMarkers.push(marker);
    }
    for (let i = 0; i < len; i++) {
      const a = path.getAt(i);
      const b = path.getAt((i + 1) % len);
      if (!a || !b) {
        continue;
      }
      const mid = new google.maps.LatLng(
        (a.lat() + b.lat()) / 2,
        (a.lng() + b.lng()) / 2
      );
      const insertAt = i + 1;
      let midDragged = false;
      let inserted = false;
      let vertexIndex = insertAt;
      const midMarker = new google.maps.Marker({
        position: mid,
        map: this.map,
        draggable: true,
        clickable: true,
        optimized: false,
        zIndex: 999999,
        cursor: 'pointer',
        icon: this.googleMidpointSquareIcon()
      });
      const insertMidAsVertex = (latLng: any) => {
        if (inserted || !latLng) {
          return;
        }
        path.insertAt(insertAt, latLng);
        inserted = true;
        vertexIndex = insertAt;
        midMarker.setIcon(this.googleVertexSquareIcon());
        this.googleMidpointMarkers.forEach(m => {
          if (m !== midMarker) {
            m.setMap(null);
          }
        });
      };
      midMarker.addListener('dragstart', (e: any) => {
        midDragged = true;
        insertMidAsVertex(e?.latLng || midMarker.getPosition());
        onChange?.();
      });
      midMarker.addListener('drag', (e: any) => {
        if (!e?.latLng) {
          return;
        }
        insertMidAsVertex(e.latLng);
        path.setAt(vertexIndex, e.latLng);
        onChange?.();
      });
      midMarker.addListener('click', (e: any) => {
        e?.stop?.();
        this.suppressGoogleMapClick = true;
        if (this.skipGoogleHandleClick || midDragged) {
          midDragged = false;
          return;
        }
        insertMidAsVertex(midMarker.getPosition());
        onChange?.();
        rebuild();
      });
      midMarker.addListener('dragend', (e: any) => {
        this.skipGoogleHandleClick = true;
        if (e?.latLng) {
          insertMidAsVertex(e.latLng);
          path.setAt(vertexIndex, e.latLng);
        }
        onChange?.();
        rebuild();
        setTimeout(() => { this.skipGoogleHandleClick = false; }, 300);
      });
      this.googleMidpointMarkers.push(midMarker);
    }
  }

  /** Keep light midpoint squares on the edges while a dark vertex is dragged. */
  private syncGoogleMidpointPositions(path: any): void {
    const len = path?.getLength?.() || 0;
    this.googleMidpointMarkers.forEach((midMarker, i) => {
      if (!midMarker?.setPosition || i >= len) {
        return;
      }
      const a = path.getAt(i);
      const b = path.getAt((i + 1) % len);
      if (!a || !b) {
        return;
      }
      midMarker.setPosition(new google.maps.LatLng(
        (a.lat() + b.lat()) / 2,
        (a.lng() + b.lng()) / 2
      ));
    });
  }

  setDrawingManager() {
    if (!this.drawingManager?.setOptions) {
      return;
    }
    this.drawingManager.setOptions({
      drawingMode: google.maps.drawing?.OverlayType?.POLYGON,
      drawingControl: false
    });
  }

  saveGeofence() {
    const geofence = this.editingPoly ? this.converPolyArrayToString(this.editingPoly) : "NULL";
    if (this.editingPoly) {
      const userId = +this.serviceLocalStorage.getUserId();
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(
        `${ApiConstants.updateBoundary}?siteid=${this.selectedSite}&userid=${userId}&boundary=${geofence}`,
        '',
        success => {
          this.ngxLoader.stop();
          if (success.status === 200) {
            this.notifyService.showSuccess(success.body.message, null);
            this.updateGeofenceState();
          }
        },
        error => {
          this.ngxLoader.stop();
          this.notifyService.showError("Error in saving geo-fence!", null);
        }
      );
    } else {
      this.updateGeofenceState();
    }
  }

  updateGeofenceState() {
    this.isGeofence = true;
    this.isGeofenceChanged = false;
    if (!this.isOsm) {
      if (this.editingPoly && this.selectedSiteObj) {
        this.selectedSiteObj.boundary = this.converPolyArrayToString(this.editingPoly);
      }
      this.editingPoly = null;
      this.showBoundary = true;
    }
    this.onReset();
  }

  addBoundryLayer(poly, editableLayers) {
    this.map.addLayer(editableLayers);
    this.polydata = new L.Control.Draw({
      edit: { featureGroup: editableLayers, remove: false },
      draw: false
    });
    const polygonArray = poly.polydata._layers[poly.polydata._leaflet_id + 1]._latlngs[0]
      .map(point => ({ lat: +point.lat, lng: +point.lng }));
    editableLayers.addLayer(L.polygon(polygonArray));
  }

  editGeofence() {
    this.polygonEditingFlag = true;
    this.polylines.forEach(polylin => {
      this.isOsm ? this.map.removeLayer(polylin) : polylin.setMap(null);
    });
    this.polylines = [];
    this.sitePolydata.forEach(poly => {
      let flag: boolean = false;
      let polydata;
      if (poly.id === this.selectedSite) {
        flag = true;
        if (this.isOsm) {
          if (Object.keys(this.polydata).length > 0) {
            this.map.removeControl(this.polydata);
          }
          const editableLayers = new L.FeatureGroup();
          this.addBoundryLayer(poly, editableLayers);
          this.map.addControl(this.polydata);
          let element: HTMLElement = document.getElementsByClassName("leaflet-draw-edit-edit")[0] as HTMLElement;
          element.click();
          this.map.on("draw:editstop", e => {
            this.map.removeControl(this.polydata);
            this.map.removeLayer(editableLayers);
            this.showBoundaries(this.selectedSiteObj);
          });
          this.map.on("draw:edited", e => {
            this.isGeofenceChanged = true;
            e.layers.eachLayer(layer => { this.editingPoly = layer.editing.latlngs[0][0]; });
            this.polylines.push(this.polydata);
            this.map.removeControl(this.polydata);
          });
        } else {
          polydata = new google.maps.Polygon({
            paths: poly.polydata.getPath(),
            map: this.map,
            fillColor: "#FFF176",
            strokeColor: "#143454",
            strokeWeight: 2,
            editable: false,
            clickable: true,
            zIndex: 10
          });
          this.polylines.push(polydata);
          if (flag) {
            this.editingPoly = polydata.getPath().getArray();
            this.attachGoogleZoneVertexHandles(polydata, () => {
              this.isGeofenceChanged = true;
              this.editingPoly = polydata.getPath().getArray();
            });
          }
        }
      } else {
        if (!this.isOsm) {
          polydata = new google.maps.Polygon({
            paths: poly.polydata.getPath(),
            map: this.map,
            editable: flag
          });
          this.polylines.push(polydata);
          if (flag) {
            google.maps.event.addListener(polydata.getPath(), "set_at", () => {
              this.isGeofenceChanged = true;
              this.editingPoly = polydata.getPath().getArray();
            });
            google.maps.event.addListener(
              polydata.getPath(), "insert_at", () => {
                this.isGeofenceChanged = true;
                this.editingPoly = polydata.getPath().getArray();
              });
            google.maps.event.addListener(
              polydata.getPath(), "remove_at", () => {
                this.editingPoly = polydata.getPath().getArray();
                this.isGeofenceChanged = true;
              });
          }
        }
      }
    });
  }

  deleteBoundary() {
    this.editingPoly = null;
    this.ngxLoader.start();
    let userId = parseInt(this.serviceLocalStorage.getUserId().toString());
    this.apiService.doPostRequestWithResponse(ApiConstants.deleteBoundary + this.selectedSite + '&userid=' + userId, '', success => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        this.isGeofence = false;
        this.isGeofenceChanged = false;
        this.onReset();
        this.notifyService.showSuccess("Site Boundary Deleted Successfully!", null);
      }
    }, error => {
      console.log(error)
      this.ngxLoader.stop();
    });
  }

  showAudit() {
    this.ngxLoader.start();
    this.apiService.doPostRequestWithResponse(ApiConstants.getBoundaryAudit + this.selectedSite, '', success => {
      this.ngxLoader.stop();
      if (success.status === 200) {
        this.dialog.open(BoundaryAuditComponent, {
          data: success.body,
          width: '800px',
          disableClose: true
        });
      } else {
        this.ngxLoader.stop();
        this.notifyService.showInfo("Audit not found", null);
      }
    }, error => {
      this.ngxLoader.stop();
      console.log(error)
    });
  }

  clearLandMarkList() {
    this.landMarkList = [];
    this.templandMarkList = [];
  }

  masterZoneChanged(zone) {
    Object.assign(this, { zones: [], showzone: false });
    this.zonePoly.forEach(polylin =>
      this.isOsm ? this.map.removeLayer(polylin) : polylin.setMap(null)
    );
    this.selectedzone = this.masterzone.find(mzone => mzone.id == zone.value);
  }

  editMasterZone() {
    this.isMasterZoneEdit = true;
  }

  removeMasterZone() {
    if (confirm("Do you want to delete the master zone set up?")) {
      this.apiService.doDeleteRequestWithResponse(ApiConstants.deleteMasterZone + this.selectedzone.id, success => {
        if (success.status == 202) {
          this.onReset();
          this.notifyService.showSuccess(success.body.message, null);
        } else {
          this.notifyService.showError("Error in updating", null);
        }
      }, error => {
        console.log(error)
      });
    }
  }

  cancelMasterZoneEdit() {
    this.isMasterZoneEdit = false;
    this.autoSelectedzone = this.selectedzone.id;
  }

  updateMasterZone(zone) {
    if (!zone?.trim()) {
      this.notifyService.showWarning("Please enter master zone name", null);
      return;
    }

    this.apiService.doPutRequestWithResponse(
      `${ApiConstants.addMasterZone}${zone}&zoneid=${this.selectedzone.id}`,
      '',
      success => {
        const messages = {
          200: () => {
            this.getMasterZone();
            Object.assign(this, {
              autoSelectedzone: this.selectedzone.id,
              isMasterZoneEdit: false
            });
            this.notifyService.showSuccess(success.body.message, null);
          },
          208: () => this.notifyService.showWarning(success.body.message, null),
          default: () => this.notifyService.showWarning("Updation failed", null)
        };
        (messages[success.status] || messages.default)();
      },
      error => console.log(error)
    );
  }

  showZones() {
    this.zonePoly.forEach(polylin => {
      this.isOsm ? this.map.removeLayer(polylin) : polylin.setMap(null);
    });
    this.zonePoly = [];
    if (this.zones.length > 0) {
      this.showzone = true;
      this.plotZone();
    } else {
      this.ngxLoader.start();
      this.apiService.doGetRequestWithResponse(ApiConstants.getZones + this.selectedzone.id, success => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          success.body.forEach(element => {
            element.viewFlag = false;
            this.apiService.doGetRequestWithResponse(ApiConstants.getzonebyid + element.id, success => {
              this.ngxLoader.stop();
              if (success.status == 200) {
                this.newzone2 = success.body;
                element.commonpoint = this.newzone2[0][1];
                element.homepoint = this.newzone2[0][2];
                this.showzone = true;
              } else if (success.status == 204) {
                this.notifyService.showInfo("Zone not found", null);
              } else {
                this.notifyService.showWarning("No Access!", null);
              }
            }, error => {
              this.ngxLoader.stop();
              console.log(error)
            });
            this.zones.push(element);
          });
          this.showzone = true;
          this.plotZone();
        } else if (success.status == 204) {
          this.notifyService.showInfo("Zone not found", null);
        } else {
          this.notifyService.showWarning("No Access!", null);
        }
      }, error => {
        this.ngxLoader.stop();
        console.log(error)
      });
    }
  }

  plotZone() {
    this.editPath = [];
    this.zones.forEach(zploy => {
      if (zploy.viewFlag) {
        let path: any = [];
        let boundaryArr: any = zploy.zonepoly.split("),(");
        let coordinates;
        boundaryArr.forEach(element => {
          if (element.includes("(")) element = element.split("(")[1];
          if (element.includes(")")) element = element.split(")")[0];
          if (this.isOsm) {
            coordinates = L.latLng(element.split(",")[0], element.split(",")[1]);
          } else {
            const lat = Number(element.split(",")[0]);
            const lng = Number(element.split(",")[1]);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
              return;
            }
            coordinates = new google.maps.LatLng(lat, lng);
          }
          path.push(coordinates);
          if (this.editZoneFlag == true) {
            if (this.editingZoneId == zploy.id) {
              this.editPath.push(coordinates);
            }
          }
        });
        let editableFlag = false;
        if (this.editZoneFlag == true) {
          if (this.editingZoneId == zploy.id) {
            editableFlag = true;
          }
        }
        if (editableFlag) {
          if (this.isOsm) {
            this.editableLayer = new L.FeatureGroup();
            this.map.addLayer(this.editableLayer);
            this.editablePolydata = new L.Control.Draw({
              edit: {
                featureGroup: this.editableLayer,
                remove: false
              },
              draw: false
            });
            this.editableLayer.addLayer(L.polygon(this.editPath));
            this.map.addControl(this.editablePolydata);
            let element: HTMLElement = document.getElementsByClassName("leaflet-draw-edit-edit")[0] as HTMLElement;
            element.click();
            this.map.on("draw:editstop", e => {
              this.map.removeControl(this.editablePolydata);
              this.removeNewZoneControl();
            });
            this.map.on("draw:edited", e => {
              this.zonePoly.push(this.editablePolydata);
              e.layers.eachLayer(layer => {
                this.editzonebounds = layer.editing.latlngs[0][0];
              });
            });
          } else {
            let polydata = new google.maps.Polygon({
              paths: this.editPath,
              editable: false,
              clickable: true,
              zIndex: 10,
              map: this.map,
              fillColor: "#e8e5d0",
              strokeColor: "#143454",
              strokeWeight: 2
            });
            this.zonePoly.push(polydata);
            this.editzonebounds = polydata.getPath().getArray();
            this.attachGoogleZoneVertexHandles(polydata);
          }
        } else {
          if (this.isOsm) {
            const editableLayers = new L.FeatureGroup();
            this.map.addLayer(editableLayers);
            editableLayers.addLayer(
              L.polygon(path).setStyle({
                color: "#143454",
                fillColor: "#58abff",
                weight: 2
              })
            )
            editableLayers.bindPopup(zploy.name);
            this.zonePoly.push(editableLayers);
          } else {
            let polydata = new google.maps.Polygon({
              paths: path,
              editable: editableFlag,
              clickable: false,
              zIndex: 2,
              map: this.map,
              fillColor: "#e8e5d0"
            });
            polydata.addListener("rightclick", event => {
              let infoWindow = new google.maps.InfoWindow();
              infoWindow.setContent(zploy.name);
              infoWindow.setPosition(event.latLng);
              infoWindow.open(this.map);
            });
            this.zonePoly.push(polydata);
            this.zonebounds = polydata.getPath().getArray();
            google.maps.event.addListener(polydata.getPath(), "set_at", () => {
              this.zonebounds = polydata.getPath().getArray();
              if (this.editZoneFlag)
                this.editzonebounds = polydata.getPath().getArray();
            });
            google.maps.event.addListener(polydata.getPath(), "insert_at", () => {
              this.zonebounds = polydata.getPath().getArray();
              if (this.editZoneFlag)
                this.editzonebounds = polydata.getPath().getArray();
            });
            google.maps.event.addListener(polydata.getPath(), "remove_at", () => {
              this.zonebounds = polydata.getPath().getArray();
              if (this.editZoneFlag)
                this.editzonebounds = polydata.getPath().getArray();
            });
          }
        }
      }
    });
  }

  hideZones() {
    this.showzone = false;
    this.clearGoogleVertexHandles();
    this.setGoogleCoveringPolygonsClickable(true);
    this.zonePoly.forEach(polylin => {
      this.isOsm ? this.map.removeLayer(polylin) : polylin.setMap(null);
    });
    this.zonePoly = [];
  }

  deleteZone(zoneid) {
    if (confirm("Do you want to delete the zone?")) {
      this.apiService.doDeleteRequestWithResponse(ApiConstants.zone + zoneid, success => {
        if (success.status == 202) {
          this.showZones();
          this.notifyService.showSuccess("Zone deleted!", null);
        } else {
          this.notifyService.showInfo("Zone not found!", null);
        }
      }, error => {
        console.log(error)
      });
    }
  }

  async enablecreatezone() {
    if (this.selectedzone != undefined && this.masterzone.length > 0) {
      if (this.isOsm) {
        if (!this.polygonEditingFlag) {
          this.polygonEditingFlag = true;
          this.newZoneLayer = new L.FeatureGroup();
          this.map.addLayer(this.newZoneLayer);
          this.newZone = new L.Control.Draw({
            edit: {
              featureGroup: this.newZoneLayer,
              remove: false
            },
            draw: {
              polygon: {
                allowIntersection: true
              },
              polyline: false,
              circle: false,
              rectangle: false,
              marker: false
            }
          });
          this.map.addControl(this.newZone);
          let element: HTMLElement = document.getElementsByClassName("leaflet-draw-draw-polygon")[0] as HTMLElement;
          element.click();
          this.map.on("draw:drawstop", e => {
            this.map.removeControl(this.newZone);
          });
          this.map.on("draw:created", e => {
            this.zonebounds = e.layer._latlngs[0];
            this.newZoneLayer.addLayer(e.layer);
            this.map.removeControl(this.newZone);
          });
        }
      } else {
        this.polygonEditingFlag = true;
        this.clearGoogleDrawnZone();
        await this.startGooglePolygonDraw(polydata => {
          polydata.setOptions({
            fillColor: '#143454',
            fillOpacity: 0.08,
            strokeColor: '#143454',
            strokeWeight: 2,
            editable: false,
            clickable: true,
            zIndex: 10
          });
          this.newGoogleZonePolygon = polydata;
          this.zonebounds = polydata.getPath().getArray();
          this.clearGoogleVertexHandles();
          this.cd.detectChanges();
        });
      }
    } else {
      this.notifyService.showWarning("Please select Master Zone", null);
    }
  }

  async createDrawingMaager() {
    await this.ensureDrawingLibrary();
    this.drawingManager = new google.maps.drawing.DrawingManager({
      drawingMode: google.maps.drawing.OverlayType.POLYGON,
      drawingControl: false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: []
      }
    });
    this.drawingManager.setMap(this.map);
  }

  savezone(zoneName) {
    if (!this.selectedzone || !this.masterzone.length) {
      this.notifyService.showWarning("Please select Master Zone", null);
      return;
    }

    if (!this.zonebounds.length) {
      this.notifyService.showWarning("Please draw the Zone on map", null);
      return;
    }

    if (!zoneName) {
      this.notifyService.showWarning("Zone name should not be empty", null);
      return;
    }

    this.ngxLoader.start();
    const param = {
      masterZone: { id: this.selectedzone.id },
      name: zoneName,
      zonepoly: this.converPolyArrayToString(this.zonebounds)
    };

    this.apiService.doPostRequestWithResponse(
      ApiConstants.addZone,
      param,
      success => {
        this.ngxLoader.stop();
        const statusHandlers = {
          200: () => {
            this.onReset();
            this.notifyService.showSuccess("Zone Created Successfully!", null);
            if (this.isOsm && this.newZoneLayer) {
              this.map.removeLayer(this.newZoneLayer);
              this.newZoneLayer = null;
            }
          },
          208: () => this.notifyService.showWarning("Zone name already exist, please change the name!", null)
        };
        statusHandlers[success.status]?.();
      },
      error => {
        this.ngxLoader.stop();
        console.log(error);
      }
    );
  }

  upadatezone() {
    let zoneboundary;
    if (this.editingZoneId != 0 && this.editZoneFlag) {
      if (this.editzonebounds[0].lat) {
        zoneboundary = this.converPolyArrayToString(this.editzonebounds);
      } else {
        zoneboundary = this.editzonebounds;
      }
      this.ngxLoader.start();
      this.apiService.doPutRequestWithResponse(ApiConstants.zone + this.editingZoneId + '&zonepoly=' + zoneboundary + '&zoneName=' + this.zoneName, '', success => {
        this.ngxLoader.stop();
        if (success.status == 200) {
          if (this.isOsm) {
            if (this.editableLayer) {
              this.map.removeLayer(this.editableLayer);
            }
            if (this.editablePolydata) {
              this.map.removeControl(this.editablePolydata);
            }
          }
          this.onReset();
          this.notifyService.showSuccess("Zone Updated Successfully!", null);
        } else if (success.status == 208) {
          this.notifyService.showWarning("Zone name already exist, please change the name!", null);
        }
      }, error => {
        this.ngxLoader.stop();
        console.log(error)
      });
    }
  }

  editZone(zoneid, zone, i) {
    this.zoneName = zone.name;
    this.zonebounds = [];
    this.editzonebounds = [];
    this.zonebounds.push(zone.zonepoly);
    this.editzonebounds.push(zone.zonepoly);
    this.editZoneFlag = true;
    this.polygonEditingFlag = true;
    this.editingZoneId = zoneid;
    this.zones[i].viewFlag = true;
    this.hideZones();
    this.plotZone();
    this.addZoneFlag = true;
  }

  onShowAllZone() {
    this.viewAllZone = !this.viewAllZone;
    this.zones.viewFlag = !this.zones.viewFlag;
    if (this.viewAllZone) {
      this.allZones = [];
      this.zones.viewFlag = !this.zones.viewFlag;
      this.zones.forEach(zploy => {
        this.zones.viewFlag = true;
        let path: any = [];
        let boundaryArr: any = zploy.zonepoly.split("),(");
        let coordinates;
        boundaryArr.forEach(element => {
          if (element.includes("(")) element = element.split("(")[1];
          if (element.includes(")")) element = element.split(")")[0];
          if (this.isOsm) {
            coordinates = L.latLng(
              element.split(",")[0],
              element.split(",")[1]
            );
          } else {
            coordinates = new google.maps.LatLng(
              element.split(",")[0],
              element.split(",")[1]
            );
          }
          path.push(coordinates);
        });
        if (this.isOsm) {
          const editableLayers = new L.FeatureGroup();
          this.map.addLayer(editableLayers);
          editableLayers.addLayer(
            L.polygon(path).setStyle({
              color: "#8B0000",
              fillColor: "#58abff",
              opacity: 0.6,
              fillOpacity: 0.65,
              stroke: "#66ccc",
              fill: "#ee9900",
              fillopacity: 0.4,
              weight: 2,
              strokeopacity: 1,
              strokewidth: 2,
              strokelinecap: round,
              strokelinejoin: round
            })
          );
          editableLayers.bindPopup(
            $('<b style="cursor:pointer"> <tr><td><b>Zone Name -</b> </td><td>' + zploy.name + '</td></tr><br><tr><td><b>Common Pin -</b> </td><td>' +
              zploy.commonpoint + '</td></tr></br><tr><td><b>Home Pin -</b> </td><td>' + zploy.homepoint + "</td></tr></b>'").click(() => { })[0]
          );
          this.allZones.push(editableLayers);
        } else {
          let polydata = new google.maps.Polygon({
            paths: path,
            editable: false,
            map: this.map,
            fillColor: "#e8e5d0"
          });
          polydata.addListener("rightclick", event => {
            let infoWindow = new google.maps.InfoWindow();
            infoWindow.setContent(zploy.name);
            infoWindow.setPosition(event.latLng);
            infoWindow.open(this.map);
          });
          this.allZones.push(polydata);
        }
      });
    }
    if (!this.viewAllZone) {
      this.allZones.forEach(zone => {
        this.isOsm ? this.map.removeLayer(zone) : zone.setMap(null);
      });
    }
  }

  onShowZone(i) {
    this.zones[i].viewFlag = !this.zones[i].viewFlag;
    this.hideZones();
    this.plotZone();
  }

  onAddApl(l) {
    if (!this.selectedCity || !this.selectedSiteObj) {
      this.notifyService.showWarning("Please select city/site", null);
      return;
    }

    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getAreaListByLocation}${this.selectedCity.locationId}`,
      success => {
        if (success.status === 200) {
          this.dialog.open(LandmarkComponent, {
            data: {
              area: success.body,
              landmark: l || null,
              site: this.selectedSiteObj
            },
            disableClose: true
          });
        } else {
          this.notifyService.showInfo("No areas found", null);
        }
      },
      error => console.log(error)
    );
  }

  onLocationArrow(l) {
    const lat = Number(l.latitude);
    const lng = Number(l.longitude);
    if (!Number.isFinite(lat) || !Number.isFinite(lng) || !this.map) {
      return;
    }
    if (this.isOsm) {
      this.map.setView([lat, lng], 17);
    } else if (this.map.setCenter) {
      this.map.setCenter({ lat, lng });
      this.map.setZoom(17);
    }
  }

  cloneMasterZone() {
    const dialogRef = this.dialog.open(ZoneRenameComponent, {
      width: "450px",
      data: this.selectedzone.name,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (!result) return;
      this.ngxLoader.start();
      this.apiService.doPostRequestWithResponse(
        `${ApiConstants.cloneMasterZone}${this.selectedzone.id}&zonename=${result}`,
        '',
        success => {
          this.ngxLoader.stop();
          const statusHandlers = {
            200: () => {
              this.getMasterZone();
              this.notifyService.showSuccess("Clone successful", null);
            },
            208: () => this.notifyService.showInfo("Zone name already exist, please change the name!", null),
            default: () => this.notifyService.showError("Error in cloning", null)
          };
          (statusHandlers[success.status] || statusHandlers.default)();
        },
        error => {
          this.ngxLoader.stop();
          this.notifyService.showError("Error in cloning", null);
        }
      );
    });
  }

  getMetroStationsCount() {
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getMetroSetupsBySiteId}${this.selectedSite}`,
      success => {
        this.metroStations = success.status === 200 ? success.body : [];
        if (success.status !== 200) {
          this.notifyService.showInfo("No metro stations found", null);
        }
      },
      error => console.log(error)
    );
  }

  markLoadedMetroStations() {
    if (this.isOsm) {
      this.markerClusterer = L.markerClusterGroup();
    } else if (!this.map?.setCenter) {
      this.initGMap(() => this.markLoadedMetroStations());
      return;
    }
    this.landMarkList.forEach(landmark => {
      if (landmark.latitude && landmark.longitude) {
        let path = "./assets/images/metro_new.png";
        if (this.isOsm) {
          const loc = L.latLng(landmark.latitude, landmark.longitude);
          const marker = new L.marker(loc, {
            icon: new L.Icon({
              iconUrl: path,
              popupAnchor: [0, 0],
              iconSize: [30, 30],
              iconAnchor: [15, 30]
            })
          })
            .bindPopup(landmark.stationName + "-" + landmark.metroRouteName);
          this.markerClusterer.addLayer(marker);
          let name = landmark.stationName;
          this.geocodes.push({ name: landmark.stationName, id: landmark.metroRouteName });
          this.als_markers.push(this.markerClusterer);
        } else {
          const lat = Number(landmark.latitude);
          const lng = Number(landmark.longitude);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            return;
          }
          const infowindow = new google.maps.InfoWindow({
            content: landmark.stationName + "-" + landmark.metroRouteName
          });
          const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            icon: {
              url: path,
              scaledSize: new google.maps.Size(30, 30),
              anchor: new google.maps.Point(15, 30)
            },
            draggable: false
          });
          let name = landmark.stationName;
          this.geocodes.push({ name: name, id: landmark.id });
          google.maps.event.addListener(marker, "click", event => {
            infowindow.open(this.map, marker);
          });
          this.als_markers.push(marker);
        }
      }
    });
    if (this.isOsm) {
      this.map.addLayer(this.markerClusterer);
    } else if (this.map?.setCenter) {
      this.markerClusterer = new MarkerClusterer({
        map: this.map,
        markers: this.als_markers,
        renderer: { render: cluster => this.renderGoogleClusterMarker(cluster) }
      });
    }
  }

  onUploadMetro() {
    let dialogRef = this.dialog.open(UploadAplComponent, {
      width: "400px",
      data: "METRO_SETUP_BATCH",
      disableClose: false
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getMetroStationsCount();
    });
  }

  getMetroStaions() {
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.getMetroSetupsBySiteId}${this.selectedSite}`,
      success => {
        const isSuccess = success.status === 200;
        const data = isSuccess ? success.body : [];
        Object.assign(this, {
          landMarkList: data,
          templandMarkList: data,
          viewStatsDetail: isSuccess,
          landmarkValue: isSuccess ? "Search by station name" : this.landmarkValue,
          metroFlag: true,
          metroStations: data
        });
        if (isSuccess) {
          this.clearMarkers();
          this.markLoadedMetroStations();
        } else {
          this.notifyService.showInfo("No metro stations found", null);
        }
      },
      error => console.log(error)
    );
  }

  onSearchKey(searchKey) {
    const searchTerm = searchKey.toLowerCase();
    this.landMarkList = this.templandMarkList.filter(data =>
      this.metroFlag
        ? data.stationName.toLowerCase().includes(searchTerm)
        : data.area.area.toLowerCase().includes(searchTerm)
    );
  }

}
